import { mergeAttributes, Node, ReactNodeViewRenderer } from '@tiptap/react';
import MentionUserCard from '../components/MentionUser';

export const UserMentionNode = Node.create({
  name: 'user-link',
  group: 'inline',
  inline: true,
  draggable: true,
  selectable: false,
  addAttributes() {
    return {
      type: {
        default: 'user',
      },
      user_id: {
        default: null,
      },
      name: {
        default: null,
      },
      label: {
        default: null,
      },
      avatar: {
        default: null,
      },
      email: {
        default: null,
      },
    };
  },
  parseHTML() {
    return [
      {
        tag: 'user-link',
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['user-link', mergeAttributes(HTMLAttributes)];
  },
  addNodeView() {
    return ReactNodeViewRenderer(MentionUserCard);
  },
});
